import { useMemo } from "react";
import { useOrderHeader } from "hooks/order";
import useCompanyPreferences from "hooks/useCompanyPreferences";
import Input from "components/ui/Input";
import FileUploader from "components/ui/FileUploader";

export default function SetOrderFooter({
  onSave,
  isLoading = false,
}) {
  const { orderHeader, updateOrderHeader } = useOrderHeader();
  const { isDocUploaderEnabled } = useCompanyPreferences();

  const docFilename = useMemo(() => {
    if (!orderHeader.ordno) return "";
    return `ORD-${orderHeader.ordno}`;
  }, [orderHeader.ordno]);

  const handleRemarkChange = (e) => {
    const { name, value } = e.target;
    updateOrderHeader({ [name]: value });
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="w-full border-t border-gray-300 mt-4" />

      {/* Two-grid layout for remarks and file upload */}
      <div className={`mt-3 px-2 grid grid-cols-1 ${isDocUploaderEnabled() ? 'lg:grid-cols-2' : ''} gap-6`}>
        {/* Left Grid - Remarks */}
        <div className="space-y-4">
          <Input
            label="Remark One"
            name="ordremark1"
            type="textarea"
            value={orderHeader.ordremark1}
            onChange={handleRemarkChange}
            placeholder="Remark"
            rows={3}
          />

          <Input
            label="Remark Two"
            name="ordremark2"
            type="textarea"
            value={orderHeader.ordremark2}
            onChange={handleRemarkChange}
            placeholder="Remark"
            rows={3}
          />
        </div>

        {isDocUploaderEnabled() && docFilename && (
          <FileUploader docFilename={docFilename} />
        )}
      </div>

      <div className="mt-4 w-full border-t border-gray-300" />

      {/* Save Button */}
      <div className="mt-3 px-2 flex justify-end">
        <button
          type="button"
          onClick={onSave}
          disabled={isLoading}
          className={`rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ${
            isLoading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-indigo-600 hover:bg-indigo-500"
          }`}
        >
          {isLoading ? (
            <div className="flex items-center">
              <svg
                className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              Saving...
            </div>
          ) : (
            "Save Order"
          )}
        </button>
      </div>
    </div>
  );
}
